import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import { TestimonialsCardSection } from "@faire/retailer-visitor-shared/components/TestimonialsCardSection/TestimonialsCardSection";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { getSettingInsiderMarketingPageImageUrls } from "@faire/retailer-visitor-shared/settings/getSettingInsiderMarketingPageImageUrls";
import { HeroBanner } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/HeroBanner";
import { InsiderBenefitsOverviewRenderer } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderBenefitsOverview/InsiderBenefitsOverviewRenderer";
import { InsiderBrandCarousel } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderBrandCarousel";
import { InsiderEarlyAccessBanner } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderEarlyAccessBanner";
import { InsiderFooter } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderFooter";
import { InsiderHowToUse } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHowToUse/InsiderHowToUse";
import { InsiderPhoneSupportSection } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderPhoneSupportSection";
import { InsiderProtectedEarlyAccessBanner } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderProtectedEarlyAccessBanner";
import { InsiderSavingsBanner } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderSavingsBanner";
import { TestimonialTitle, useTestimonials } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/TestimonialTitle";
import { InsiderFAQSection } from "@faire/retailer-visitor-shared/views/user/InsiderMembership/InsiderSetting/InsiderFAQSection";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { trackInsiderLoggedOutInsiderMarketingPageView } from "@faire/web-api--source/events/insider/view/loggedOutInsiderMarketingPage";
import * as React from "react";
import { useEffect } from "react";
export var LoggedOutInsiderMarketingPage = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var hasProtectedEarlyAccessPerk = useInsiderFeatureEligibility().hasProtectedEarlyAccessPerk;
    var testimonials = useTestimonials();
    useEffect(function() {
        trackInsiderLoggedOutInsiderMarketingPageView();
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FaireHelmet, {
                title: strictLocalize({
                    id: "G0EH/2",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Get free shipping with Faire Insider"
                        }
                    ]
                }),
                description: strictLocalize({
                    id: "wX0H96",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Insider is the best way to shop on Faire. Sign up for Faire today and unlock a free trial of Insider."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(HeroBanner, {}),
            /*#__PURE__*/ _jsx(InsiderBenefitsOverviewRenderer, {}),
            /*#__PURE__*/ _jsx(InsiderSavingsBanner, {}),
            /*#__PURE__*/ _jsx(InsiderBrandCarousel, {}),
            hasProtectedEarlyAccessPerk ? /*#__PURE__*/ _jsx(InsiderProtectedEarlyAccessBanner, {}) : /*#__PURE__*/ _jsx(InsiderEarlyAccessBanner, {}),
            /*#__PURE__*/ _jsx(InsiderPhoneSupportSection, {}),
            /*#__PURE__*/ _jsx(InsiderHowToUse, {
                imageUrls: getSettingInsiderMarketingPageImageUrls()
            }),
            /*#__PURE__*/ _jsx(TestimonialsCardSection, {
                title: /*#__PURE__*/ _jsx(TestimonialTitle, {}),
                testimonials: testimonials,
                backgroundColor: Decorative.tint.teal,
                textColor: Core.text.default
            }),
            /*#__PURE__*/ _jsx(InsiderFAQSection, {}),
            /*#__PURE__*/ _jsx(InsiderFooter, {}),
            /*#__PURE__*/ _jsx(RetailerFooter, {})
        ]
    });
};
